export default __webpack_public_path__ + "static/media/Background_00034.172040a5.png";